import { React, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Model/Share/Network/FetchModule.js';

import PartnerMemberView from '../../Model/Individual/MemberModel/PartnerMemberView.js';

export default function PartnerGymMemberPage() {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // 파트너 체육관 회원 목록 불러오기 //
  useEffect(() => {
    setIsLoading(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('member/partner_gym/', 'GET');

        if (responseData.status === 200) setData(responseData.data);
        else if (responseData.status === 401) history.push('/login');

        setIsLoading(false);
      }
    )();
  }, [history])

  // 회원 상세 클릭시 //
  function onClickMemberDetail(value) {
    window.open('/member/partner_gym/detail/' + value.memberId, '_blank');
  }

  return (
    <TopLevelWrapper>
      <PartnerMemberView totalData={data} isLoading={isLoading} memberShipDetailClick={onClickMemberDetail} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;